import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import type { AdminAccountConsent } from "@/api/admin/accounts";

// Channel = which contact-method consent flag gates this field. Wiring the
// (label, value, consent-flag) triple via `channel` instead of separate
// label/hasConsent props prevents mis-pairing (e.g. an email value gated
// on the phone consent flag).
type Channel = "email" | "phone";

const CHANNEL_LABEL: Record<Channel, string> = {
  email: "Email",
  phone: "Phone",
};

// When consent is granted: text renders normally and is selectable.
// When consent is declined: grayed out AND user-select: none — so admins
// can't drag-select to copy. The goal is for the ergonomic default action
// to respect consent, not to make extraction impossible.
export interface ConsentGatedFieldProps {
  value: string | null;
  consent: AdminAccountConsent;
  channel: Channel;
}

export const ConsentGatedField = ({ value, consent, channel }: ConsentGatedFieldProps) => {
  const hasConsent = channel === "email" ? consent.contact_email : consent.contact_phone;
  return (
    <Flex alignItems="center" gap={3}>
      <Box minWidth="160px">
        <Text fontWeight="medium">{CHANNEL_LABEL[channel]}</Text>
      </Box>
      <Text
        color={hasConsent ? "gray.800" : "gray.400"}
        sx={{ userSelect: hasConsent ? "auto" : "none" }}
      >
        {value ?? "—"}
      </Text>
    </Flex>
  );
};
